import { FETCH_USER, RESET_USER } from "../../constants/action-constants";
import { getAccessToken } from "../../services/browserStorage";
import { webApiCheck } from "../../services/commonMethods";
import { fetchWebApi } from "../../webApis/apiResource";

export const requestUser = (urlEndPoint) => {
  return async (dispatch) => {
    const response = await fetchWebApi(getAccessToken(), urlEndPoint);
    if (webApiCheck(response)) {
      dispatch(fetchUser(response.data));
    }
  };
};

const fetchUser = (data) => {
  return {
    type: FETCH_USER,
    payload: data,
  };
};

export const resetUser = () => {
  return {
    type: RESET_USER,
  };
};
